import { stdObject } from "../data/types/stdObject";
import { toPrice } from "./toPrice";

export const getPricesList = ({
  type,
  value,
  pricesList,
  pricesRates,
  label,
  titles = false,
  user,
}: {
  type: string;
  value: number;
  pricesList: stdObject;
  pricesRates: Array<stdObject>;
  label: string;
  titles?: boolean;
  user: stdObject;
}) => {
  pricesList = pricesList ?? {};
  let priceExists = Object.values(pricesList).some(
    (e: any) => typeof value === "number" && e.PRELTA === Number(value),
  );
  let totalPrices = pricesRates.map((e: stdObject) => {
    return {
      label: titles
        ? `${toPrice(pricesList[e.CODTAR]?.PRELTA ?? 0)} (${e.NOMTAR})`
        : toPrice(pricesList[e.CODTAR]?.PRELTA ?? 0),
      value: pricesList[e.CODTAR]?.PRELTA ?? 0,
    };
  });

  if (user[`${type}US1`] > 1) {
    totalPrices.push({
      label,
      value: "another",
    });
  }

  return priceExists
    ? totalPrices
    : [
        {
          label: toPrice(value),
          value: Number(value),
        },
        ...totalPrices,
      ];
};
